/*!
 * MLE.Client.Components.Error.Server
 * File: server.error.js
 * Copyright (c) 2025 Runtime Software Development Inc.
 * Version 2.1
 * MIT Licensed
 */

import React from "react";

const ServerError = () => {
    return (
        <div>
            <h3>Server Error</h3>
            <p>An error has occurred. <em>Please contact the site administrator for assistance.</em></p>
        </div>
    );
}

export default ServerError;
